import React, { useState } from 'react';
import Modal from 'react-modal';
import './css/NavigationModal.css';

const NavigationModal = ({ isOpen, onRequestClose, onNavigate }) => {
  const [gridX, setGridX] = useState('');
  const [gridY, setGridY] = useState('');

  const handleGo = () => {
    const x = parseInt(gridX, 10);
    const y = parseInt(gridY, 10);
    if (!isNaN(x) && !isNaN(y)) {
      onNavigate(x, y);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="navigation-modal"
      overlayClassName="navigation-modal-overlay"
    >
      <h2 className="navigation-modal-title">Navigate to Coordinates</h2>
      <div className="navigation-input-group">
        <label>
          Grid X:
          <input
            type="number"
            value={gridX}
            onChange={(e) => setGridX(e.target.value)}
            className="navigation-input-field"
          />
        </label>
      </div>
      <div className="navigation-input-group">
        <label>
          Grid Y:
          <input
            type="number"
            value={gridY}
            onChange={(e) => setGridY(e.target.value)}
            className="navigation-input-field"
          />
        </label>
      </div>
      <div className="navigation-button-group">
        <button onClick={handleGo} className="navigation-modal-button">Go</button>
        <button onClick={onRequestClose} className="navigation-modal-button">Close</button>
      </div>
    </Modal>
  );
};

export default NavigationModal;
